import { render, staticRenderFns } from "./LoginExternoEscritoriov2.vue?vue&type=template&id=3a626ff0&scoped=true&"
import script from "./LoginExternoEscritoriov2.vue?vue&type=script&lang=js&"
export * from "./LoginExternoEscritoriov2.vue?vue&type=script&lang=js&"
import style0 from "./LoginExternoEscritoriov2.vue?vue&type=style&index=0&id=3a626ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a626ff0",
  null
  
)

export default component.exports